import { Link } from 'react-router-dom'

export default function SelectGroupEmpty() {
  return (
    <div className="flex flex-col pt-2 pb-4">
      <div className="flex justify-center text-center px-4">
        <div className='space-y-2 text-black'>
          <p className='pb-4'>Olá!</p>
          <p>Você ainda não está participando de nenhum Bolão, não se preocupe, vou te explicar como começar:</p>
          <p className='pt-2'>Caso você queira criar um novo Bolão e convidar seus amigos clique <Link to="/groups/new" className='font-bold text-green-500'>aqui.</Link></p>
          <p className='pt-2'>Ou, caso você queira se juntar a um Bolão existente, você precisa usar um link/convite que foi compartilhado contigo em algum grupo de bate-papo, redes social ou email. Ou contacte seu amigo que está organizando o Bolão.</p>
        </div>
      </div>
    </div>
  )
}
